import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import MapaCarreraServices from "./MapaCarrera.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getMapaCarrera = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_MAPA_CARRERA,
      payload: true,
    });
    debugger
    const respCursos = await MapaCarreraServices.getMapaCarreraCursos(filters);
    const respCompetencias = await MapaCarreraServices.getMapaCarreraCompetencias(filters)
    dispatch({
      type: actions.GET_MAPA_CARRERA,
      payload: {
        mapaCarrera: {
          mapaCursos: respCursos.data,
          mapaCompetencias: respCompetencias.data
        }
      },
    });
    dispatch({
      type: actions.MAPA_CARRERA_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.MAPA_CARRERA_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_MAPA_CARRERA,
      payload: false,
    });
  }
};